
/* carDetails handler functions*/
function returnData(selectedOptions, selectIndex, vname = null){
  var ra = selectedOptions;
  var searchedData = [];
  var r = selectIndex;
  $.each(carModelsArray, function(key,val){
    var i = 0;
    $.each(ra, function(k,v){
      if(val[k] != ra[k]){				
        return false;
      }
      i++;	
    });
    if(r == i){
      if (vname) {
        searchedData.push(val[vname]);
      } else {
        searchedData.push(val[r]);
      }
      	
    }		
  });	
  return searchedData.filter(onlyUnique);
}

function isOnCarCollection() {
  return !!document.querySelector('.car-collection-container');
}
  
function ifOnFindifySearchResults() {
  return window.location.pathname.indexOf('/search-results') > 0;
}


var getTagsForCollection = (function() {
  var cache = {};

  return function(collection) {
    if (cache[collection]) {
      return cache[collection];
    }

    var colID = 6;
    var firstTagID = 7;
    var secTagID = 8;
    var titleTagID = 9;
    var tags = [];
    for (var i = 0; i < carModelsArray.length; i += 1) {
      if (carModelsArray[i][colID] === collection) {
        tags[0] = carModelsArray[i][firstTagID];
        tags[1] = carModelsArray[i][secTagID];
        tags[2] = carModelsArray[i][titleTagID];
        break;
      }
    }

    cache[collection] = tags;
    return tags;
  }
})();

function arrayToLowerCase(arr) {
  var result = [];

  for (var i = 0; i < arr.length; i += 1) {
    result.push(arr[i].toLowerCase && arr[i].toLowerCase());
  }

  return result;
}

function onlyUnique(value, index, self) { 
    return self.lastIndexOf(value) === index;
}

function transformValueForFindify(value) {
  var splitted = value.split(' ');
  var resultStr = '';
  for (var i = 0; i < splitted.length; i += 1) {
    var word = splitted[i];
    resultStr += word[0].toUpperCase();
    resultStr += word.slice(1, word.length).toLowerCase();
    resultStr += ' ';
  }

  return resultStr.trim();
}

function setCookie(cname,cvalue,exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
  
 function getSelectedCars() {
   var customerCars = '';
   var cars = customerCars.length > 0 && customerCars !== '""'
     ? customerCars
     : getCookie('Vehicles');
  
   return cars.split(',').filter(function(car) {
     return car.length > 0;
   });
 }

function findCarText(checkText){
  const foundCar = carModelsArray.find(function(i){
    return i.find(function(x){
      return x.indexOf(checkText) >= 0;
    });
  });
  
  if(!foundCar) return '';
  return foundCar[9];
}

var selectedTag = 'data-selected="true"';

function getSelectedCar(cars) {
  for (var i = 0; i < cars.length; i += 1) {
    if (~cars[i].indexOf(selectedTag)) {
      return $(cars[i]);
    }
  }

  return null;
}
  
function getSelectedCarTags($car) {
  if (!$car) {
  	return [];
  }
  return [
  	$car.attr('data-first-tag'),
    $car.attr('data-second-tag')
  ];
}

function unselectCars(cars) {
  var result = [];
  for (var i = 0; i < cars.length; i += 1) {
    result.push(cars[i].replace(selectedTag, ''));
  }
  return result;
}

function selectCar(href, cars) {
  var result = [];
  for (var i = 0; i < cars.length; i += 1) {
    var $car = $(cars[i]);
    if ($car.attr('href') === href) {
      if (cars[i].indexOf(selectedTag) === -1) {
        result.push(cars[i].replace('<a', '<a ' + selectedTag));
      } else {
        result.push(cars[i]);
      }
    } else {
      result.push(cars[i].replace(selectedTag, ''));
    }
  }
  return result;
}

function initSelectedCarsList(cars) {
  jQuery('.sc-results').html('');
  for(i=0; i < cars.length;i++) {
    if(cars[i]!='') {
      jQuery('.sc-results').append('<li class="sc-list"><span class=sc-list-inner>' + cars[i] + '<span><a href="javascript:void(0)" class="r-icon"></a></li>');
    }
  }
}
  
function updateSelectedCarsList() {
  var cars = getSelectedCars();
  jQuery('.sc-results li').remove();
  for(i = 0; i < cars.length; i++) {
    if(cars[i] !== '') {
      jQuery('.sc-results').append('<li class="sc-list"><span class=sc-list-inner>'+cars[i]+'</span><a href="javascript:void(0)" class="r-icon"></a></li>');
    }
  }
  if(jQuery('ul.sc-results li:visible').hasClass('sc-list')) {
    jQuery('.sc-overlay').hide();
  }
  else {
    jQuery('.sc-overlay').show();
  }
}

function stringifyCars(cars) {
  var result = '';

  for (var i = 0; i < cars.length; i += 1) {
    var carName = $(cars[i]).text();
    if (carName) {
      if (result.length > 0) {
        result += ', ';
      }
      result += carName;
    }
  }

  return result;
}

function saveSelectedCars(customerID, cars, beforeSend, onFinish) {
  setCookie("Vehicles",cars,30);
  var $selectedCar = getSelectedCar(cars);
  var selectedCarName = ($selectedCar && $selectedCar.text()) || '';
  $.post('/cart/update.js', 'attributes[Selected Car]=' + selectedCarName);
  if (customerID && customerID.length > 0) {
    return $.ajax({
      type: 'POST',
      url: 'https://order.findify.io/uro-tuning-customer-cars-sync',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({
        customerID: customerID,
        cars: cars
      }),
      beforeSend: function() {
        beforeSend && beforeSend();
      },
      success: function() {
        console.log('successfully updated cars');
        onFinish && onFinish();
      },
      error: function(err) {
        console.log('Erro while updating cars: ', err);
        onFinish && onFinish();
      }
    });
  }
  onFinish && onFinish();
}
  
function updateSelectedCarTitle($car) {
  var title = typeof $car === 'string' ? $car : $car.text();
  $('.close-select.c-car').text(title);
  $('.close-select.car-selector').text(title);
  $('.selectCar-mobile-text.sm-item').text(title);
}

/* END carDetails handler */
  
function ifProductButtonShowFilters() {
  var pathName = window.location.pathname;
  return ['/collections/', '/search-results'].find(function(i){ return pathName.indexOf(i) > -1}) &&
    	!['/collections/deals', '/collections/swag'].find(function(col) { return pathName.indexOf(col) > -1 });
}
  
function toggleMobileLeftSidebar() {
  if (window.innerWidth < 960) {
     $('#showLeftPush').click();
  }
}
  

 var shop_url = '';
var seriesText = "Series";
var chassisText = "Chassis";
var modelText = "Model";
var engineText = "Engine";
var driveText = "DriveTrain";

 var customerID = "";
var stubFunction = function() {};

function getSelectorContainer($self) {
  return $self.closest('.selection');
}

function updateSelectorValue($self, value) {
  $self.closest('.sc-car').attr('data-value', value);
};

function getSelectedData($container) {
  return {
    make: $container.find('.sc-make').attr('data-value') || '',
    series: $container.find('.sc-series').attr('data-value') || '',
    chassis: $container.find('.sc-chassis').attr('data-value') || '',
    model: $container.find('.sc-model').attr('data-value') || '',
    engine: $container.find('.sc-engine').attr('data-value') || '',
    drive: $container.find('.sc-drive').attr('data-value') || '',
    year: $container.find('.sc-year').attr('data-value') || ''
  };
}

function showGoButton() {
  jQuery('.sc-go').show();
}

function hideGoButton() {
  jQuery('.sc-go').hide();
}

function hideFitmentStatus() {
  jQuery('.fitment-status').hide();
}

var fitmentColors = {
  green: '#91ea56',
  red: '#fc5235'
};

function showFitmentStatus(carUrl) {
  var carTags = arrayToLowerCase(getTagsForCollection(carUrl));
  var $fitmentStatus = $('.fitment-status');
  var fitmentNotes = $('.fitment-note-metafields');
  var checkFitmentNote = $('.show-fitment-note');
  $fitmentStatus.show();
  checkFitmentNote.hide();
  var productTags = arrayToLowerCase($fitmentStatus.attr('data-tags').split(', '));
  var isFitModel = productTags.includes(carTags[0]) || productTags.includes(carTags[1]);
  var fitmentStatusText = isFitModel
        ? '<span class="custom-icon-true">âœ”</span><span style="color: ' + fitmentColors.green + '"> This product fits your vehicle</span>'
        : '<span class="custom-icon-false">âœ˜</span><span style="color: ' + fitmentColors.red + '"> This product does not fit your vehicle</span>';
  $fitmentStatus.html(fitmentStatusText);
  if(fitmentNotes && fitmentNotes.text() && isFitModel){
  	  checkFitmentNote.show();
  }

  return isFitModel;
}

function addCar(cars, carName, year) {

  car = null
  
  $.each(carModelsArray, function(key,val){
    if (val[7] == carName) {
		car = val
    }
  })
  
  //var collectionTags = getTagsForCollection(carURL);
  var title = car[7];
  var finalVal = '<a href="'+shop_url+'/collections/'+car[6]+'" class="selected-results">'+ title +'</a>';
  // jQuery('.close-select').text(title);
  var cleanedCars = unselectCars(cars);
  cleanedCars.push(finalVal);
  cleanedCars = cleanedCars.filter(onlyUnique);
  cleanedCars[cleanedCars.length - 1] = cleanedCars[cleanedCars.length - 1].replace('<a ', '<a ' + selectedTag);
  return cleanedCars;
}

function showMakeButton(isFitModel, carURL) {
  var color = isFitModel ? fitmentColors.green : fitmentColors.red;
  var $makeCarBtn = $('.make-selected-car');
  $makeCarBtn.show();
  $makeCarBtn.css({
    color: color,
    'border-color': color
  });
  $makeCarBtn.attr('data-car', carURL);
  $makeCarBtn.attr('data-fits', isFitModel);
}

function hideMakeButton() {
  $('.make-selected-car').hide();
}

/* Car year */

var isDevMode = window.location.search.indexOf('devmode=true') !== -1;
var isLoginForm = window.location.href.indexOf('/account/login') !== -1;
var isRegisterForm = window.location.href.indexOf('/account/register') !== -1;

function initYearLogic() {
  
  // Save users cars if it is a first page loaded after registration.
  if (getCookie("UserRegisteredWithCar") && customerID) {
    saveSelectedCars(
      customerID,
      getSelectedCars(),
      function() {},
      function() {}
    );
    // Delete cookie
    document.cookie = 'UserRegisteredWithCar=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  // Run car year logic only on login/register pages.
//   if (!isDevMode || !(isLoginForm || isRegisterForm)) {
  if (!isLoginForm && !isRegisterForm) {
    jQuery('#register_form_car_details').hide();
    return;
  }
  
  fillYearDropdown();
  showCarInRegistrationForm();
  makeRegisterFormDisabled(true);
  
  jQuery(document).on("click",".s7-dropdown .dropdown-content a", onYearFieldClicked);
  <!-- jQuery(document).on('click', '#create_customer .action-btn input[type="submit"]', onRegisterBtnClicked); -->
}

function onYearFieldClicked() {
  var $self = jQuery(this);
  var year = $self.text() || '';
  
  fillFormYearField(year);
  makeRegisterFormDisabled(false);

  // Car selected in a native cars list control.
  var selectedCarName = getCarSelectedBefore();
  // Car selected in a dropdown in registration form.
  var selectedInForm = getCarSelectedInForm();
  if (selectedCarName && selectedInForm) { 
    var selectedCar = findCarByName(selectedInForm);

    updateSelectorValue(jQuery(this), year);

    urlVal = [selectedCar[7]];
    successAction(getSelectorContainer($self), selectedCar[6]);
  } else {
    var selectedData = getSelectedData(getSelectorContainer($self));

    updateSelectorValue(jQuery(this), year);

    var carDrive = [selectedData.make, selectedData.series, selectedData.chassis, 
                    selectedData.model, selectedData.engine, selectedData.drive,'', year];
    var storeDrive = returnData(carDrive, 6, 7);

    urlVal = storeDrive;
    successAction(getSelectorContainer($self), storeDrive[0]);
  }
}

/**
* Fill hidden field used form creating car-year tag after registration.
*/
function fillFormYearField(value) {
  jQuery('#car_year_tag').val(value || '');
}

function onRegisterBtnClicked(ev) {
  var year = getSelectedYear();
  if (!year) {
  	ev.preventDefault();
    ev.stopPropagation();
    return;
  }
  
  var updCars = [];
  // Car selected in a native cars list control.
  var selectedCarName = getCarSelectedBefore();
  // Car selected in a dropdown in registration form.
  var selectedInForm = getCarSelectedInForm();

  if (selectedCarName && selectedCarName === selectedInForm) {
    updCars = updCar(getSelectedCars(), urlVal[0], year);
  } else if (selectedCarName && selectedInForm && selectedCarName !== selectedInForm) {
    // If user has selected vehicle but he choose another one from a list in a registration form
    // we'll make this car as selected.
    updCars = updCar(getSelectedCars(), urlVal[0], year, true);
  } else {
    updCars = addCar(getSelectedCars(), urlVal[0], year); 
  }
  
  if (updCars && updCars.length) {
    // UserRegisteredWithCar cookie used to assign selected vehicles 
    // to a registered user after page reloaded and user receives his customerID
    setCookie("UserRegisteredWithCar", true, 30);

  	saveSelectedCars(
      customerID,
      updCars,
      function() {},
      function() {}
    );
  }
}

function getSelectedYear() {
  return jQuery('#create_customer .sc-year').attr('data-value') || '';
}

function updCar(cars, carURL, year, makeSelected) {
  var collectionTags = getTagsForCollection(carURL);
  var title = collectionTags[2] || '';
  var finalVal = '<a ' +
      (makeSelected ? selectedTag : '') + 
      'data-first-tag="' + (collectionTags[0] || '') + 
      '" data-second-tag="' + (collectionTags[1] || '') + '"' +
      (year ? ' data-year="' + year + '"' : '') +
      ' href="'+shop_url+'/collections/'+carURL+'" class="selected-results">'+ title +'</a>';
  
  if (makeSelected) {
    // If currently selected not carURL vehicle but we shoueld check it as selected
    // we should first unselect all previous.
    cars = unselectCars(cars);
  }
  
  // Replace existing record to a new one.
  for(var i in cars) {    
    if (cars[i].indexOf(title) !== -1) {
      var prev = cars[i];
      cars[i] = finalVal;
      if (prev.indexOf(selectedTag) !== -1) {
      	cars[i] = cars[i].replace('<a ', '<a ' + selectedTag);
      }
    }
  }
  return cars;
}

function showYearField() {
  jQuery('.sc-year').show();
}

function hideYearField() {
  jQuery('.sc-year').hide();
}

function fillYearDropdown() {
  if (jQuery('.sc-year').length) {
    var yearsRange = {from: 1975, to: ((new Date()).getFullYear() + 1)};
    var yearsList = [];

    var list = jQuery('<div></div>');
    for(var i = yearsRange.to; i >= yearsRange.from; i--) {
      list.append('<a href="javascript:void(0)">'+i+'</a>');
    }
    jQuery('.sc-year .dropdown-content').html(list.html()); 
  } 
}
  
function getCarSelectedBefore() {
  var $selectedCar = getSelectedCar(getSelectedCars());
  return ($selectedCar && $selectedCar.text()) || '';
}

function showCarInRegistrationForm() {
  var selectedCarName = getCarSelectedBefore();
  if (selectedCarName) {
    var $container = jQuery('.selection[data-action="register"]');
    $container.find('.sc-year').closest('.selection').find('.sc-make').addClass('c-detail');
    $container.find('.sc-year').removeClass('c-detail');
    
    jQuery('#already_selected_car .dropSelect p').text(selectedCarName);
    
    var dropdown = jQuery('#already_selected_car .dropdown-content');
    dropdown.html('');
    
    var myCars = getSelectedCars();
    for(var i in myCars) {
      var carConfigName = jQuery(myCars[i]).text();
      dropdown.append('<a href="javascript:void(0)" ' + 
                      (selectedCarName === carConfigName ? ' class="select-active" ' : '') + 
                      '>'+carConfigName+'</a>');
    }
    
    dropdown.append('<a href="javascript:void(0)" data-action="new_car_selection">Select new car</a>');
    jQuery('#already_selected_car').show();
    jQuery(document).on("click","#already_selected_car .dropdown-content a", onSelectedCarDdClicked);
  }
}

/**
* If user has already selected cars - we'll show them as a list in a dropdown in the registration form.
* User can select any of these cars or choose an option "Select new car".
* If user choose new car full form will be shown. 
* If he select any of existed cars - he should selected only car year.
*/
function onSelectedCarDdClicked() {
  var $self = jQuery(this);  
  var $container = $self.closest('#register_form_car_details').find('ul.selection');
  
  makeRegisterFormDisabled(true);
  
  notSuccessAction($container);
  $container.find('.sc-make').hide();
  $container.find('.sc-series').hide();
  $container.find('.sc-chassis').hide();
  $container.find('.sc-engine').hide();
  $container.find('.sc-drive').hide();
  $container.find('.sc-model').hide();
  updateSelectorValue($container.find('.sc-make'), '');
  updateSelectorValue($container.find('.sc-year'), '');
  $container.find('.sc-make .dropSelect p').text('Make');
  $container.find('.sc-year .dropSelect p').text('Year');
  
  if ($self.attr('data-action') === 'new_car_selection') {
    $container.find('.sc-make').css('display','block');
  } else {
    $container.find('.sc-year').css('display','block');
  }
}

function getCarSelectedInForm() {
  var $car = jQuery('#already_selected_car .dropdown-content a.select-active');
  return  $car.attr('data-action') !== 'new_car_selection' ? $car.text() : '';
}

function findCarByName(carName){
  return carModelsArray.find(function(i){
    return i.find(function(x){
      return x == carName;;
    });
  }) || '';
}

/**
* Disable/enable form submit button.
* @param {boolean} status - true = make form enabled; false = make it disabled
*/
function makeRegisterFormDisabled(status) {
  <!-- jQuery('#create_customer .action-btn input[type="submit"]').attr('disabled', status || false); -->
}

/* End of car year logic */



var selectorActions = {
  success: {
    'check_car': function(carURL) {
      var isFitModel = showFitmentStatus(carURL);
      showMakeButton(isFitModel, carURL);
    },
    'select_car': showGoButton,
    'register': showYearField
  },
  notSuccess: {
    'check_car': function() {
      hideFitmentStatus();
      hideMakeButton();
    },
    'select_car': hideGoButton,
    'register': hideYearField
  }
};

function notSuccessAction($container) {
  var action = $container.attr('data-action');
  if (action === 'register') {
  	makeRegisterFormDisabled(true);
  }
  return selectorActions.notSuccess[action] && selectorActions.notSuccess[action]();
}

function successAction($container, carUrl) {
  var action = $container.attr('data-action');
  if (action === 'register' && getSelectedYear()) {
  	makeRegisterFormDisabled(false);
  }
  return selectorActions.success[action] && selectorActions.success[action](carUrl);
}

function initCarSelector() {
  var urlVal = '';

  var allCarData = ['','','','','','',''];
  var storeCarData = returnData(allCarData, 0);

  for(var i in storeCarData) {
    jQuery('.sc-make .dropdown-content').append('<a href="javascript:void(0)">'+storeCarData[i]+'</a>');
  }
  
  initYearLogic();

  jQuery(document).on("click", ".s1-dropdown .dropdown-content a", function() {
    var $self = jQuery(this);
    var $container = getSelectorContainer($self);
    notSuccessAction($container);
    $container.find('.sc-series .dropSelect p').text(seriesText);
    $container.find('.sc-chassis').hide();
    $container.find('.sc-engine').hide();
    $container.find('.sc-drive').hide();
    $container.find('.sc-model').hide();
    $container.find('.sc-chassis .dropSelect p').text(chassisText);
    $container.find('.sc-engine .dropSelect p').text(engineText);
    $container.find('.sc-drive .dropSelect p').text(driveText);
    $container.find('.sc-series .dropdown-content a').remove();
    var make = $self.text() || '';
  
    updateSelectorValue(jQuery(this), make);

    var carMake = [make,'','','','','',''];
    var storeMake = returnData(carMake, 1);

    for(var i in storeMake ) {
      $container.find('.sc-series .dropdown-content').append('<a href="javascript:void(0)">'+storeMake[i]+'</a>');
    }

    $self.parents('.sc-car').next().css('display','block');
  });

  jQuery(document).on("click",".s2-dropdown .dropdown-content a", function() {
    var $self = jQuery(this);
    var $container = getSelectorContainer($self);
    var selectedData = getSelectedData($container);

    $container.find('.sc-chassis .dropSelect p').text(chassisText);
    $container.find('.sc-engine').hide();
    $container.find('.sc-drive').hide();
    $container.find('.sc-model').hide();
    $container.find('.sc-engine .dropSelect p').text(engineText);
    $container.find('.sc-drive .dropSelect p').text(driveText);
    notSuccessAction($container);
    $container.find('.sc-chassis .dropdown-content a').remove();
    $container.find('.sc-model .dropdown-content a').remove();
    $container.find('.sc-engine .dropdown-content a').remove();
    $container.find('.sc-drive .dropdown-content a').remove();

    var series = $self.text() || '';

    updateSelectorValue(jQuery(this), series);
    
    var carSeries = [selectedData.make, series,'','','','',''];
    var storeSeries = returnData(carSeries, 2);

    if(storeSeries != '') {
      for(var i in storeSeries ) {
        $container.find('.sc-chassis .dropdown-content').append('<a href="javascript:void(0)">'+storeSeries[i]+'</a>');
      }
        
        setTimeout(function() {
          if(storeSeries.length == 1) {
            // console.log($container.find('.s3-dropdown:visible .dropdown-content a'));
            $container.find('.s3-dropdown:visible .dropdown-content a').click();
          }
          else {
            $container.find('.sc-chassis .dropSelect p').text(chassisText);
          }
        },100);

      $self.parents('.sc-car').next().css('display','block');
    }

  });

  jQuery(document).on("click",".s3-dropdown .dropdown-content a", function() {
    var $self = jQuery(this);
    var $container = getSelectorContainer($self);
    var selectedData = getSelectedData($container);

    notSuccessAction($container)
    $container.find('.sc-engine').hide();
    $container.find('.sc-drive').hide();

    $container.find('.sc-model .dropdown-content a').remove();
    $container.find('.sc-engine .dropdown-content a').remove();
    $container.find('.sc-drive .dropdown-content a').remove();
    var chassis = $self.text() || '';
    
    updateSelectorValue(jQuery(this), chassis);
    
    $container.find('.sc-model .dropdown-content').empty();
    var carChassis = [selectedData.make, selectedData.series, chassis, '','','',''];
    var storeChassis = returnData(carChassis, 3);

    if(storeChassis != ''){

      setTimeout(function(){
      if(storeChassis.length == 1) {
        $container.find('.s4-dropdown:visible .dropdown-content a').click();

      }
      else {
        $container.find('.sc-model .dropSelect p').text(modelText);
      }
    },100);

      for(var i in storeChassis ) {
        $container.find('.sc-model .dropdown-content').append('<a href="javascript:void(0)">'+storeChassis[i]+'</a>');
      }  
      var next = $self.parents('.sc-car').next().css('display','block');
    }
    else {
      var carModel = [selectedData.make, selectedData.series, chassis, '','','',''];
      var storeModel = returnData(carModel, 4);
      if(storeModel != '') {
        setTimeout(function(){
          if(storeModel.length == 1) {
            $container.find('.s5-dropdown:visible .dropdown-content a').click();
          }
          else {
            $container.find('.sc-engine .dropSelect p').text(engineText);
          }
        },100);

        for(var i in storeModel ) {
          $container.find('.sc-engine .dropdown-content').append('<a href="javascript:void(0)">'+storeModel[i]+'</a>');
        }
        $container.find('.sc-engine').css('display','block');
      }
      else {
          var carEngine = [selectedData.make, selectedData.series, chassis, '','','',''];
          var storeEngine = returnData(carEngine, 5);
          if(storeEngine != '') {

            setTimeout(function(){
              if(storeEngine.length == 1) {
                $container.find('.s6-dropdown:visible .dropdown-content a').click();

              }
              else {
                $container.find('.sc-drive .dropSelect p').text(driveText);
              }
            },100);

            for(var i in storeEngine ) {
              $container.find('.sc-drive .dropdown-content').append('<a href="javascript:void(0)">'+storeEngine[i]+'</a>');
            }
            $container.find('.sc-drive').css('display','block');
          }
          else {
            var carDrive = [selectedData.make, selectedData.series, chassis, '','','',''];
            var storeDrive = returnData(carDrive, 6, 7);
            successAction($container, storeDrive[0]);
            urlVal = storeDrive;
          }
      } 
    }
  });
  
  
  jQuery(document).on("click",".s4-dropdown .dropdown-content a", function() {
    var $self = jQuery(this);
    var $container = getSelectorContainer($self);
    var selectedData = getSelectedData($container);

    notSuccessAction($container);
    $container.find('.sc-drive').hide();
    $container.find('.sc-engine .dropdown-content a').remove();
    $container.find('.sc-drive .dropdown-content a').remove();
    
    var model = $self.text() || '';

    updateSelectorValue(jQuery(this), model);

    var carModel = [selectedData.make, selectedData.series, selectedData.chassis, model, '','',''];
    var storeModel = returnData(carModel, 4);

    if(storeModel != ''){
      setTimeout(function(){
        if(storeModel.length == 1) {
          $container.find('.s5-dropdown:visible .dropdown-content a').click();
        }
        else {
          $container.find('.sc-engine .dropSelect p').text(engineText);
        }
      },100);
      
      for(var i in storeModel ) {
        $container.find('.sc-engine .dropdown-content').append('<a href="javascript:void(0)">'+storeModel[i]+'</a>');
      }
      $self.parents('.sc-car').next().css('display','block');
    }
    else {
    var carEngine = [selectedData.make, selectedData.series, selectedData.chassis, model, '','',''];
  var storeEngine = returnData(carEngine, 5);
      if(storeEngine != '') {
        setTimeout(function(){
          if(storeEngine.length == 1) {
            $container.find('.s6-dropdown:visible .dropdown-content a').click();
          }
          else {
            $container.find('.sc-drive .dropSelect p').text(driveText);
          }
        },100);

        for(var i in storeEngine ) {
            $container.find('.sc-drive .dropdown-content').append('<a href="javascript:void(0)">'+storeEngine[i]+'</a>');
        }
        $container.find('.sc-drive').css('display','block');
      }
      else {
        var carDrive = [selectedData.make, selectedData.series, selectedData.chassis, model, '','',''];
        var storeDrive = returnData(carDrive, 6, 7);
        successAction($container, storeDrive[0]);
        urlVal = storeDrive;
      }
    } 
  });
  
  jQuery(document).on("click",".s5-dropdown .dropdown-content a", function() {
    var $self = jQuery(this);
    var $container = getSelectorContainer($self);
    var selectedData = getSelectedData($container);
    
    $container.find('.sc-drive .dropSelect p').text(driveText);
    notSuccessAction($container);
    $container.find('.sc-drive .dropdown-content a').remove();
    var engine = $self.text() || '';

    updateSelectorValue(jQuery(this), engine);

    var carEngine = [selectedData.make, selectedData.series, selectedData.chassis, selectedData.model, engine, '',''];
    var storeEngine = returnData(carEngine, 5);
    if(storeEngine != '') {
      setTimeout(function(){
        if(storeEngine.length == 1) {
          $container.find('.s6-dropdown:visible .dropdown-content a').click();

        }
        else {
          $container.find('.sc-drive .dropSelect p').text(driveText);
        }
      },100);
      for(var i in storeEngine ) {
        $container.find('.sc-drive .dropdown-content').append('<a href="javascript:void(0)">'+storeEngine[i]+'</a>');
      }

      $self.parents('.sc-car').next().css('display','block');
    }
    else {
      var carDrive = [selectedData.make, selectedData.series, selectedData.chassis, selectedData.model, engine, '',''];
      var storeDrive = returnData(carDrive, 6, 7);
      successAction($container, storeDrive[0]);
      console.log('storeDrive5: '+storeDrive);
      urlVal = storeDrive;
    }
  });
  
  jQuery(document).on("click",".s6-dropdown .dropdown-content a", function(){
    var $self = jQuery(this);
    var drive = $self.text() || '';
    var selectedData = getSelectedData(getSelectorContainer($self));

    updateSelectorValue(jQuery(this), drive);
    
    var carDrive = [selectedData.make, selectedData.series, selectedData.chassis, selectedData.model, selectedData.engine, drive,'',''];
    var storeDrive = returnData(carDrive, 6, 7);

    console.log('storeDrive: '+storeDrive);
    urlVal = storeDrive;
    successAction(getSelectorContainer($self), storeDrive[0]);
  });

  jQuery(document).on("click",".sc-link", function() {
    var updCars = addCar(getSelectedCars(), urlVal[0]);
    saveSelectedCars(
      customerID,
      updCars,
      function() { $('.selector-loading').addClass('open'); },
      function() {
        $('.selector-loading').removeClass('open');
        if (ifOnFindifySearchResults()) {
          var $selectedCar = getSelectedCar(updCars);
          updateSelectedCarTitle($selectedCar);
          updateSelectedCarsList();
          window.applyDefaultFilters && window.applyDefaultFilters(getSelectedCarTags($selectedCar));
          urlVal = '';
  		  allCarData = ['','','','','','',''];
          $('.sc-car:not(.sc-make)').hide();
          hideGoButton();
          $('.sc-make .dropSelect p').text('Make');
          $('.sc-dropdown').hide();
          toggleMobileLeftSidebar();
          $('.invitational-popup-overlay').hide();
          $('.invitational-popup-container').hide();
          $('.link-products').attr('href', $selectedCar.attr('href'));
          $('.body-overlay').hide();
          return;
        }
        
        car = null

        $.each(carModelsArray, function(key,val){
          if (val[7] == urlVal[0]) {
              car = val
          }
        })
        
        window.location.href = shop_url+'/collections/'+car[6];
      }
    );
  });
}
  
function showInvitationalPopup(parentEvent){
  var isVehicle = getCookie('Vehicles');
  var isAlreadyShown = getCookie('showInvitationalPopup');

  if(!isVehicle && !isAlreadyShown){
      if (parentEvent) {
        parentEvent.preventDefault();
        parentEvent.stopPropagation();
        parentEvent.stopImmediatePropagation();
      }
      document.cookie = 'showInvitationalPopup=true; path=/;';

      var dropdown = $('.sc-dropdown');
      var mobileSelection = $('#showLeftPush');
      var invitationalPopupContainer = $('<div class="invitational-popup-container"></div>');
      var invitationalPopupOverlay = $('<div class="invitational-popup-overlay"></div>');
      var invitaionalPopup = $('<div class="invitational-popup"><div class="invitational-popup-text">We noticed you don\'t have a car selected!</div></div>');
      var buttonsContainer = $('<div class="invitational-popup-buttons-container"></div>');
      var buttonSelect = $('<div>Select a vehicle</div>');
      var buttonExit = $('<div>Browse unfiltered</div>');

      buttonSelect.click(function(e){
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          invitaionalPopup.hide();
          invitationalPopupOverlay.css('z-index', 5);
          $('.invitational-popup-overlay').hide();
          if(dropdown.length > 0){
            dropdown.show();
          }
          if(mobileSelection.length > 0 && !mobileSelection.hasClass('active')){
            mobileSelection.click();

          }
      });

      buttonExit.click(function(e){
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          invitationalPopupContainer.hide();
        if(window.location.href.indexOf('search-results') == -1){
        	window.location = shop_url+'/collections/all';
        }
//           if(dropdown.length > 0){
//             dropdown.show();
//           }
      });

      invitationalPopupOverlay.click(function(e){
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          invitationalPopupContainer.hide();
          if(dropdown.length > 0){
            dropdown.show();
          }
      });



      invitationalPopupContainer.append(invitationalPopupOverlay);
      buttonsContainer.append(buttonSelect);
      buttonsContainer.append(buttonExit);
      invitaionalPopup.append(buttonsContainer);
      invitationalPopupContainer.append(invitaionalPopup);
      $('body').prepend(invitationalPopupContainer);
    }
}



jQuery(function() {
  jQuery('.make-selected-car').click(function() {
    $self = jQuery(this);
    var carURL = $self.data('car');
    var isFitModel = $self.data('fits');
    
    if (!carURL || carURL.length === 0) {
      return;
    }
    
    $self.attr('disabled', 'disabled');
    var updCars = addCar(getSelectedCars(), carURL);

    if (isFitModel) {
      saveSelectedCars(
        customerID,
        updCars,
        function() {
          $('.checker-loading').show();
        },
        function() {
          $('.checker-loading').hide();
          window.location.reload();
        }
      );
      return;
    }

    saveSelectedCars(customerID, updCars, function() { $('.checker-loading').show(); }, function() {
      $('.checker-loading').hide();
      window.location.href = shop_url + '/collections/' + carURL;
    });
  });

  var myCars = getSelectedCars()
  initSelectedCarsList(myCars);
  setCookie("Vehicles", myCars, 30);
    
  var window_url = window.location.href;
  var isMobile = window.innerWidth <= 767;
  var crop_url = window_url.split('collections/')[1];
  var string = "collections";
  var substring = "vendor";
  var isTher = window_url.indexOf(substring) == -1;

  if(isTher == 'true' && jQuery('body').hasClass('template-collection')) {
    jQuery('.close-select').text(jQuery('.page-header h2').text());
    jQuery('.selectCar-mobile-text').text(jQuery('.page-header h2').text()); 
  }
  else {
    function handleProductsClickOnOpenFilters(ifSelectedCar){
      if(ifProductButtonShowFilters()){
        $('#showLeftPush').click(function(){
          $('a[href="/collections/all"]').click(function(e){
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
    		var isAlreadyShown = getCookie('showInvitationalPopup');
            if(!ifSelectedCar && !isAlreadyShown){
              showInvitationalPopup(e);
            }else if($('.findify-mobile-filter-button').length > 0){
              $('#showLeftPush').click();
              $('.findify-mobile-filter-button').click();
            }
          });
        });
      }else if(ifSelectedCar){
      	$('a[href="/collections/all"]').attr('href', selectedCar.attr('href'));
      }else{
      	$('#showLeftPush').click(function(){
            $('a[href="/collections/all"]').click(function(e){
              if(!getCookie('showInvitationalPopup')){
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                showInvitationalPopup(e);
              }
            });
        });
      }
    }
    
    var selectedResults = jQuery('.selected-results');
    if (selectedResults.length != 0) {
      var selectedCar = $('.sc-list .selected-results[data-selected="true"]').eq(0);
      var checkText = selectedCar.text();
      if(isMobile){
        $('a[href="/"]').each(function (_, i) {
           var item = $(i);
           if(item.text() === 'Home'){
             item.attr('href', selectedCar.attr('href'));
           }
        });

        handleProductsClickOnOpenFilters(true);
      }else{
        $('a[href="/collections/all"]').attr('href', selectedCar.attr('href'));
      }
      // var productText = findCarText(checkText);
      jQuery('.close-select').text(checkText);
      jQuery('.selectCar-mobile-text').text(checkText);
    } else { 
      if(isMobile){
        handleProductsClickOnOpenFilters(false);
      }
      
      jQuery('.close-select').text('SELECT VEHICLE');
      jQuery('.selectCar-mobile-text').text('SELECT YOUR VEHICLE');
    }
	
    if(jQuery('body').hasClass('template-index') && selectedResults.length === 0) {
      jQuery('.sc-dropdown').show();
    }
//     if(ifOnFindifySearchResults()) {
//       showInvitationalPopup();
//     }
  }

  jQuery(document).on('click', function(e) { 
    if(jQuery(e.target).hasClass("closePopup")){
      jQuery(this).toggleClass('sc-red'); 
      jQuery('.sc-dropdown').toggle();
    }
    else if(jQuery(e.target).hasClass("car-selector")){ 
      jQuery('.sc-dropdown').toggle();
    }
    else if(jQuery(e.target).hasClass("c-car")){
      jQuery('.sc-dropdown').toggle();
    }
    else if(jQuery(e.target).parents('div').hasClass("sc-dropdown")){
      console.log('no-function');
    }
    else if(jQuery(e.target).hasClass("r-icon")) {
      console.log('no-function');
    }
    else if(jQuery(e.target).hasClass("sm-item")) {
      jQuery('#showLeftPush').click();
      jQuery('.sc-dropdown').show();
    }
    else if(jQuery('body').hasClass('cbp-spmenu-push-toright')) {
      if(jQuery(e.target).hasClass("body-overlay")) {
        jQuery('#showLeftPush').click();
      } 
    }
    else{
      jQuery('.sc-dropdown').hide();
    }
  });
  
  function createFitmentTable() {
  	 var fitmentStatus = $('.fitment-status');
     var fitmentDescription = $('.fitment-description-tab');
     var exceptionModels = ['tiguan', 'beetle', 'golf/gti/rabbit', '.:r models', 'touareg', 'jetta', 'q3'];
     var uniqueModelsCount = {};
    
     for(var i = 0; i < carModelsArray.length; i++){
       var model = carModelsArray[i][2].split(' ').slice(0, -1).join(' ') + ' ' +carModelsArray[i][1];
       if(exceptionModels.indexOf(carModelsArray[i][1].toLowerCase()) > -1){
         model = carModelsArray[i][2].split(' ').slice(0, -1).join(' ');
       }
       if(!(model in uniqueModelsCount)){
         uniqueModelsCount[model] = 1;
       }else{
         uniqueModelsCount[model] += 1;
       }
     }
    
     if(fitmentStatus.length > 0){
    	var fitmentCars = fitmentStatus.attr('data-tags').split(', ');
      	var fitmentTableValues = fitmentCars.map(function(fitCar){
            var car = carModelsArray.find(function(i){
                return i[7] && i[7].toLowerCase() === fitCar.toLowerCase();
            });
            if(car){
              	if(exceptionModels.indexOf(car[1].toLowerCase()) > -1){
              		return [car[0], car[2], car[3], car[4], car[5]];
                }
                return [car[0], car[1] + ' ' + car[2], car[3], car[4], car[5]];
            }
            return;
        });
        var existingFitmentValues = fitmentTableValues.filter(function(i){
			return i;
        });
       	
       	var checkObj = {};
        var groupedModels = {};
       	for(var i = 0; i < existingFitmentValues.length; i++){
           if(!(existingFitmentValues[i][1] in checkObj)){
             checkObj[existingFitmentValues[i][1]] = 1;
           }else{
             checkObj[existingFitmentValues[i][1]] += 1;
           }
           if(checkObj[existingFitmentValues[i][1]] === uniqueModelsCount[existingFitmentValues[i][1]] && uniqueModelsCount[existingFitmentValues[i][1]] > 1){
			  groupedModels[existingFitmentValues[i][1]] = [existingFitmentValues[i][0], existingFitmentValues[i][1], 'All', 'All', 'All'];
           }
       	}
       	
       	for(i in groupedModels){
           existingFitmentValues = existingFitmentValues.filter(function(model){
       			return !(i === model[1])
           });
           existingFitmentValues.push(groupedModels[i]);
       	}
       	
       	existingFitmentValues.sort(function(a, b) {
          if (a[0].localeCompare(b[0]) === 0){
          	return a[1].localeCompare(b[1]);
          }
          return a[0].localeCompare(b[0]);
       	});
       
//       	if(existingFitmentValues){
//           var mainHeader = $('<p style="font-size: 18px; font-family: rajdhani; font-weight: bold; margin-bottom: 10px; text-transform: capitalize;">'+
//                                'This part fits the following vehicles</p>');
//             var fitmentTableContainer = $('<div style="overflow-x: auto"></div>');
//           	var fitmentTable = $('<table class="fitment-description-table">');
//           	var header = $('<tr class="table-header"><th>Make</th><th>Model</th><th>Submodel</th><th>Engine</th><th>Drivetrain</th></tr>');
//           	fitmentTable.append(header);
//             existingFitmentValues.map(function(car){
//               var row = $('<tr class="table-row"><td>'+car[0]+'</td><td>'+car[1]+'</td><td>'+car[2]+'</td><td>'+car[3]+'</td><td>'+car[4]+'</td></tr>');
//               fitmentTable.append(row);
//             });
          	
//           	fitmentTableContainer.append(fitmentTable);
//           	fitmentDescription.append(mainHeader);
//           	fitmentDescription.append(fitmentTableContainer);
//         }
       
       if(existingFitmentValues){
          var mainHeader = $('<p style="font-size: 18px; font-family: rajdhani; font-weight: bold; margin-bottom: 10px; text-transform: capitalize;">'+
                               'This part fits the following vehicles</p>');
            var fitmentTableContainer = $('<div style="overflow-x: auto"></div>');
          	var fitmentTable = $('<table class="fitment-description-table">');
          	var header = $('<tr class="table-header"><th>Make</th><th>Model</th><th>Submodel</th><th>Engine</th><th>Drivetrain</th></tr>');
          	fitmentTable.append(header);
            existingFitmentValues.map(function(car){
              var row = $('<tr class="table-row"><td>'+car[0]+'</td><td>'+car[1]+'</td><td>'+car[2]+'</td><td>'+car[3]+'</td><td>'+car[4]+'</td></tr>');
              fitmentTable.append(row);
            });
          var fitmentTextLength = document.querySelector('.fitment-note-metafields').textContent.replace(/\s/g,'').length;
          var fitmentText = document.querySelector('.fitment-note-metafields').textContent.replace(/\n/g ,'').split('*');
          if(fitmentTextLength > 0 && fitmentText.length < 3){
            fitmentTable.append($('<tr class="table-row"><td colspan="5" class="fitment-note-metafield-text"><div class="fitment-note-metafield-text-insert"><span>Important fitment note!</span> '+fitmentText[fitmentText.length - 1]+'</div></td></tr>'));
            fitmentTable.prepend($('<tr class="table-row"><td colspan="5" class="fitment-note-metafield-text"><div class="fitment-note-metafield-text-insert"><span>Important fitment note!</span> '+fitmentText[fitmentText.length - 1]+'</div></td></tr>'));
          }
          if(fitmentText.length > 2){ 
            fitmentTable.append($('<tr class="table-row"><td colspan="5" class="fitment-note-metafield-text"><div class="fitment-note-metafield-text-insert"><span>Important fitment note!</span></div></td></tr>'));
            fitmentTable.prepend($('<tr class="table-row"><td colspan="5" class="fitment-note-metafield-text"><div class="fitment-note-metafield-text-insert fitment-note-metafield-text-insert-top"><span>Important fitment note!</span></div></td></tr>'));
            fitmentText.map(function(text){
              if(text.replace(/\s/g,'').length > 0){
                  fitmentTable.find('.fitment-note-metafield-text-insert').append($('<p>'+text+'</p>'));
              }

            })
          }
          	
          	fitmentTableContainer.append(fitmentTable);
          	fitmentDescription.append(mainHeader);
          	fitmentDescription.append(fitmentTableContainer);
        }
     }
  }
  
  initCarSelector();
  createFitmentTable();
  
//   $('input[name=q]').click(function(e){
//   	showInvitationalPopup(e);
//   });
  
  $('a[href="/collections/all"]').click(function(e){
  	showInvitationalPopup(e);
  });
    
  jQuery(document).off("click",".nav-popup");
  
  jQuery(document).on("click",".sc-tabs .s-tabs a", function() {

    var v = $(this).parents(".s-tabs").index();

    $(this).parents(".s-tabs").addClass("sc-active").siblings().removeClass('sc-active');
    if(jQuery(window).width()>768) {
      $(".sc-content").animate({left: (-1)*v*(277)},"slow");
    }
    if(jQuery(window).width()<768) {
      $(".sc-content").animate({left: (-1)*v*(256)},"slow");
    }
  });
  
  jQuery('.sc-tabs .s-tabs').first().click();
  
  function toggleSelectors($container, $initiator) {
    var initiatorClass = $initiator.attr('class');
    var $selectors = $container.find('.sc-car');
    $selectors.each(function(i, elem) {
      var $elem = $(elem);
      if ($elem.attr('class') !== initiatorClass) {
        $elem.find('.dropdown-content').slideUp(0);
      }
    });
  }

  jQuery(document).on("click",".dropSelect", function() {
    var $self = jQuery(this);
    $self.toggleClass('border_bottom').siblings('.dropdown-content').slideToggle(200);
    toggleSelectors(getSelectorContainer($self), $self.closest('.sc-car'))
  });

  jQuery(document).on("click",".dropdown-content a", function() {
    var th = jQuery(this);
    var th_val = th.text();
    th.addClass('select-active').siblings().removeClass('select-active');
    th.parent().slideUp().siblings('.dropSelect').find('p').toggleClass('border_bottom').text(th_val);
    th.parents('.sc-car').siblings('.sc-car').find('.dropdown-content').slideUp();
  });

  jQuery(document).on('click', '.sc-results .sc-list-inner a.selected-results', function(e) {
    e.preventDefault();
    var $self = $(this);
    const updMyCars = selectCar($(this).attr('href'), myCars);
    saveSelectedCars(customerID, updMyCars, function() { $('.selector-loading').addClass('open'); }, function() {
      $('.selector-loading').removeClass('open');
      window.location.href = $self.attr('href');
    });
  });

  jQuery(document).on("click",".select-tab a", function() {
    jQuery('.sc-results li').remove();
  });

  jQuery(document).on("click",".result-tab a", function() {
    updateSelectedCarsList();
  });
  
  
  jQuery(document).on("click",".sc-results .r-icon", function() {
    myCars = [];
    var _this = jQuery(this).parent(); 
    _this.remove();
    var list_length = jQuery('ul.sc-results .sc-list:visible').length;
    for(i=0;i<list_length;i++) {
      var liText = jQuery('ul.sc-results .sc-list:visible').eq(i).find('.sc-list-inner').html();
      myCars.push(liText);
    }
    $car = _this.find('a.selected-results');
    if ($car.data('selected') && myCars.length > 0) {
      myCars[myCars.length - 1] = myCars[myCars.length - 1].replace('<a', '<a ' + selectedTag);
    }
 	
    var $removedCar = _this.find('a.selected-results');
    var isSelectedCarRemoved = !!$removedCar.attr('data-selected');
    
    saveSelectedCars(
      customerID,
      myCars,
      function() {
        $('.selector-loading').addClass('open');
      },
      function() {
        $('.selector-loading').removeClass('open');
        var $selectedCar = getSelectedCar(myCars);
        if ($selectedCar) {
        	updateSelectedCarTitle($selectedCar);
          	$('.sc-list-inner a[href="' + $selectedCar.attr('href') + '"]').attr('data-selected', true);
        } else {
        	updateSelectedCarTitle('Select Vehicle');
        }
        if (isSelectedCarRemoved) {
          $('a[href="' + $removedCar.attr('href') + '"]')
          	.attr('href', $selectedCar ? $selectedCar.attr('href') : '/collections/all');
          if (isOnCarCollection()) {
        	window.location.href = $selectedCar
           	  ? $selectedCar.attr('href')
              : '/collections/all';
            return;
          }
          
          if (ifOnFindifySearchResults()) {
            	var selectedCarTags = getSelectedCarTags($selectedCar);
            	window.applyDefaultFilters && window.applyDefaultFilters(selectedCarTags);
            	toggleMobileLeftSidebar();
//           	window.location.href = window.location.pathname;
            return;
          }
        }
      }
    );
   
    if(jQuery('ul.sc-results li:visible').hasClass('sc-list')) {
      jQuery('.sc-overlay').hide();
    }
    else {
      jQuery('.sc-overlay').show();
    }
  });
    
});